import api from './api';
import type { ApiResponse, BankAccount } from '@/types';

// =============================================================================
// Bank accounts (ArtDent 260924) — the clinic accounts a POS / bank-transfer
// payment lands in. Gated by feature:payments_enabled server-side.
// =============================================================================

export interface BankAccountData {
  name: string;
  iban?: string | null;
  is_active?: boolean;
}

export const getBankAccounts = async (options: { activeOnly?: boolean } = {}) => {
  const params = new URLSearchParams();
  if (options.activeOnly) params.append('active_only', 'true');
  const response = await api.get<ApiResponse<BankAccount[]>>(`/bank-accounts?${params}`);
  return response.data.data;
};

export const createBankAccount = async (data: BankAccountData) => {
  const response = await api.post<ApiResponse<BankAccount>>('/bank-accounts', data);
  return response.data.data;
};

export const updateBankAccount = async (id: string, data: Partial<BankAccountData>) => {
  const response = await api.put<ApiResponse<BankAccount>>(`/bank-accounts/${id}`, data);
  return response.data.data;
};

export const deleteBankAccount = async (id: string) => {
  await api.delete(`/bank-accounts/${id}`);
};
